import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';

import GeneralInformation from './careplan_list/GeneralInformation';
import MedicalHistory from './careplan_list/MedicalHistory';
import CareRoutine from './careplan_list/CareRoutine';

const Careplan = (props) => {
  const clientCareplan = props.clientCareplan;
  const clientBackend = props.clientBackend;
  const onSave = (updatedSection) => {
    const updatedCareplan = {
      ...updatedSection,
    };
    clientBackend.careplan.updateCareplan(updatedCareplan);
  };

  return (
    <Stack
      sx={{
        p: 2,
      }}
      spacing={2}
    >
      <GeneralInformation
        generalInformation={clientCareplan.generalInformation}
        onSave={onSave}
      />
      <MedicalHistory
        medicalHistory={clientCareplan.medicalHistory}
        onSave={onSave}
      />
      <CareRoutine
        careRoutine={clientCareplan.careRoutine}
        onSave={onSave}
      />
    </Stack>
  );
};

Careplan.propTypes = {
  clientCareplan: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
};

export default Careplan;
